import { defineStore } from "pinia"
import { ref } from "vue"

export const useJourneyStore = defineStore("journey", () => {
    const isJourneyFormSaved = ref(true)
    const isEditVueFlowAutoSave = ref(true)

    /**
     * 重置所有狀態至初始值
     */
    function reset() {
        isJourneyFormSaved.value = true
        isEditVueFlowAutoSave.value = true
    }

    return {
        isJourneyFormSaved,
        isEditVueFlowAutoSave,
        reset,
    }
})
